import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SurveyCustomerService } from 'app/services/models/survey-customer.service';
import { SurveyService } from 'app/services/models/survey.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-survey-customer-send',
  templateUrl: './survey-customer-send.component.html',
  styleUrls: ['./survey-customer-send.component.scss']
})
export class SurveyCustomerSendComponent implements OnInit {
  @Input() data: { companyId: number, companyName: string, mail: string };
  form: FormGroup;
  surveys: any[] = [];
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private surveyService: SurveyService,
    private surveyCustomerService: SurveyCustomerService,
    private toastrSerivce: ToastrService
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      surveyId: [null, [Validators.required]],
      mail: [null, [Validators.required, Validators.email]]
    });
    if (this.data.mail)
      this.form.patchValue({
        mail: this.data.mail
      })
    await this.getAllSurvey();
  }

  async getAllSurvey() {
    const data = await this.surveyService.getAllSurvey(0, 1000);
    console.log(data);
    this.surveys = data.surveys;
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async surveyCustomerSend() {
    if (this.form.valid) {
      console.log(this.form.value);
      const data = await this.surveyCustomerService.createSurveyCustomer(this.data.companyId, this.form.value.surveyId, this.form.value.mail);
      if (data.status) {
        this.toastrSerivce.success(data.message);
        this.closeModal();
      } else {
        this.toastrSerivce.error(data.message);
      }
    }
  }
}
